module.exports = __webpack_public_path__ + "img/marketplace-illustration.fd2a2fd5.svg";